import { useCallback } from "react";
import { adminService } from "services/adminService";

function useAdminAgentService() {
  const getAgentInstructions = useCallback(async (agent) => {
    try {
      const response = await adminService.getAgentInstructions(agent);

      if (response && response.error) {
        throw new Error(response.error);
      }

      // Check if response has data property
      if (response && response.data) {
        return response.data;
      } else if (response) {
        return response;
      } else {
        throw new Error("No data received from service");
      }
    } catch (error) {
      console.error("💥 Hook: Error fetching agent instructions:", error);
      throw error;
    }
  }, []);

  const updateAgentInstructions = useCallback(async (agentNumber, instructions) => {
    console.log("🚀 Hook: Starting updateAgentInstructions for agent:", agentNumber);
    const response = await adminService.updateAgentInstructions(agentNumber, instructions);
    return response;
  }, []);

  return { getAgentInstructions, updateAgentInstructions };
}

export default useAdminAgentService;
